import { rSetLocation } from "../Slice/rLocationSlice";

export const rLocation = (rLocationId, rLocationName) => (dispatch) => {
    dispatch(rSetLocation({rLocationId, rLocationName}));
}

export default rLocation;